$(document).ready(function () {
	var autoComplete = new Bloodhound({
		datumTokenizer: window.Bloodhound.tokenizers.obj.whitespace('value'),
		queryTokenizer: window.Bloodhound.tokenizers.whitespace,
		remote: {
			wildcard: '%QUERY',
			url: '/find_v2/_autocomplete?prefix=%QUERY',
			transform: function (list) {
				var suggestions = $.map(list.hits,
					function (hit) {
						var h = hit.query;
						return { value: hit.query };
					});

				return suggestions;
			}
		}
	});

	autoComplete.initialize();

	$('.header .search input, #main-search').typeahead({
		hint: true,
		highlight: true,
		minLength: 1
	},
		{
			name: 'autoComplete',
			displayKey: 'value',
			source: autoComplete,
			templates: {
				suggestion: function (data) {
					return '<li><a href=' + window.ssmSearchPageUrl + '?q=' + data.value +  '>' + data.value + '</a></li>';
				}
			}
		});

	$('.header .search input, #main-search').on('typeahead:render', function (evt, item, isAsync, dataset) {
		$('.tt-dataset').attr('role', 'list');
	});
});
